const eventFromEEMock = {
    id: 85804,
    meeting_code: '2025BTM_4',
    title: 'ICSC Fall and Winter 2025 Board of Trustees Meeting',
    meeting_type: '{meeting_type}',
    address_2: '',
    state_province: 'District of Columbia',
    country: 'United States',
    city: 'Washington',
    zip: '20007',
    begin_date: '',
    end_date: '',
    start_date: '1758009600',
    finish_date: '1758214800',
    save_date: 'N',
    begin_timestamp: '2025-09-16 08:00:00 +00:00',
    end_timestamp: '2025-09-18 17:00:00 +00:00',
    travel: 'Y',
    app_image: 'https://stage.icsc.com/assets/images/default/events.jpg',
    app_image_small: 'https://stage.icsc.com/assets/images/default/events88x88.jpg',
    imis_reg: 'Y',
    imis_reg_override: 'Y',
    meeting_type_desc: 'Committee Events',
    registration:
        'https://stage.icsc.com/events-and-programs/details/icsc-fall-and-winter-2025-board-of-trustees-meeting',
    link: 'https://stage.icsc.com/events-and-programs/details/icsc-fall-and-winter-2025-board-of-trustees-meeting',
    full_site_link:
        'https://stage.icsc.com/events-and-programs/details/icsc-fall-and-winter-2025-board-of-trustees-meeting',
    display_date: '',
    is_registered: 'N',
    print_confirmation: '',
    get_directions:
        'https://maps.google.com/maps?saddr=&daddr=2800+Pennsylvania+Avenue+NW%2C+Washington%2C+District+of+Columbia+20007%2C+United+States&hl=en',
    region_name: '',
    show_program_button: 'N',
    quicklinks: [
        {
            quicklink_name: 'Book Hotel',
            quicklink_url: 'https://www.marriott.com/default.mi',
        },
    ],
    youtube: '',
    phone_featured_image: 'https://stage.icsc.com/assets/images/default/events578x300.jpg',
    phone_small_image: 'https://stage.icsc.com/assets/images/default/events280x280.jpg',
    tablet_featured_image: 'https://stage.icsc.com/assets/images/default/events1045x544.jpg',
    tablet_small_image: 'https://stage.icsc.com/assets/images/default/events337x337.jpg',
    map_address: '2800 Pennsylvania Avenue NW Washington , District of Columbia 20007 United States',
    event_url_title: 'icsc-fall-and-winter-2025-board-of-trustees-meeting',
    session_count: '0',
    speaker_count: '0',
    featured_speakers: '',
    additional_information: '',
    event_description: '',
    committee: '',
    description_photo: '',
    address_1: '2800 Pennsylvania Avenue NW',
    address_3: '',
    coordinators: '{coordinators}',
    contact_info: [],
    pricing: {
        member: '',
        nonmember: '',
        student: '',
        public_official: '',
        message: '',
    },
    sponsors: [],
    sessions: [],
    event_pricing: [{}],
    presentations: [],
    documents: [
        {
            document_title: 'Mid-Winter 2025 BOT Materials',
            document_file:
                'https://stage.icsc.com/uploads/event_documents/Mid-Winter_2025_Board_of_Trustees_Pre_Read_Materials.pdf',
            document_description: '<p>Additional details can be added here.</p>',
            document_url: '',
        },
    ],
};

export default eventFromEEMock;
